"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MinimaError = function (_Error) {
    (0, _inherits3.default)(MinimaError, _Error);

    // 扩展与服务：5***

    // 启动、停止、卸载：4***
    function MinimaError(message, code) {
        var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, _classCallCheck3.default)(this, MinimaError);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MinimaError.__proto__ || (0, _getPrototypeOf2.default)(MinimaError)).call(this, message));

        _this._code = code;
        _this._error = error;
        return _this;
    }
    // 框架与事件：1***
    // 安装：2***
    // 解析：3***

    (0, _createClass3.default)(MinimaError, [{
        key: "code",
        get: function get() {
            return this._code;
        }
    }, {
        key: "internalError",
        get: function get() {
            return this._error;
        }
    }]);
    return MinimaError;
}(Error);

MinimaError.notMarkFailedForEmptyDependencies = 3009;
MinimaError.notActionForResolveFailed = 40009;
MinimaError.notActionForUninstalled = 4008;
MinimaError.notStartedForStartLevel = 4007;
MinimaError.notStartedForActivatorLoadOrStartFailed = 4006;
exports.default = MinimaError;
//# sourceMappingURL=MinimaError.js.map